import { UseQueryOptions, UseQueryResult, useQuery } from 'react-query';
import { captureException } from '@sentry/react';
import { SerializedFile } from '@enmon/commons/lib/enmon';

import { useServices } from 'services/useServices';
import { QUERY_KEYS } from 'utils/queryKeys';
import { GetFileLinkResponse } from 'services/api/enmonTools';

export const useFileLink = (
  file?: SerializedFile | null,
  options: UseQueryOptions<GetFileLinkResponse> = {},
): UseQueryResult<GetFileLinkResponse, unknown> => {
  const {
    enmonTools: {
      files: { getFileLink },
    },
  } = useServices();

  return useQuery({
    queryKey: QUERY_KEYS.enmonTools.files.link(file?._id),
    queryFn: async ({ signal }) => {
      if (!file) {
        return null;
      }

      return await getFileLink(file._id, signal);
    },
    enabled: Boolean(file),
    onError: error => {
      console.error(error);
      captureException(error);
    },
    ...options,
  });
};
